import { useIntl } from '@mfw/components';
import Box from '@mui/material/Box';
import React from 'react';

import {
  NotificationsCenter as NotificationsCenterComponent,
  NotificationsCenterTab,
} from '../../components/NotificationsCenter';
import {
  useMarkAllNotificationsRead,
  useUnreadNotificationsCount,
} from '../../hooks/notifications';
import { useUploadWorkerContext, useAuthContext } from '../../context';
import { NotificationsUploads } from './NotificationsUploads';
import { NotificationsList } from './NotificationsList';
import Tabs from '../../components/Tabs';
import messages from './messages';

export const NotificationsCenter = () => {
  const { formatMessage } = useIntl();
  const { tasks } = useUploadWorkerContext();
  const { currentUser } = useAuthContext();
  const { data: unreadCount = 0 } = useUnreadNotificationsCount();
  const { mutate: markAllRead } = useMarkAllNotificationsRead();

  // ERRORS COUNT TOO. Filtering on `uploading` alone meant a failed upload
  // DROPPED OUT of the badge — the one moment the user most needs to be sent
  // here, rendered as if everything had finished.
  const numberOfUploads = React.useMemo(
    () =>
      tasks.filter(
        (task) => task.status === 'uploading' || task.status === 'error',
      )?.length || undefined,
    [tasks],
  );

  const total = (numberOfUploads ?? 0) + (unreadCount ?? 0);

  const handleOpen = React.useCallback(() => {
    if (unreadCount > 0) {
      markAllRead();
    }
  }, [unreadCount, markAllRead]);

  if (!currentUser?.hasFinishedOnboarding) return null;

  return (
    <NotificationsCenterComponent
      title={formatMessage(messages.notificationCenter)}
      badge={total || undefined}
      onOpen={handleOpen}
    >
      <Tabs initialValue={'notifications'}>
        <Tabs.TabsList>
          <NotificationsCenterTab
            label={formatMessage(messages.notifications)}
            badge={unreadCount || undefined}
            value="notifications"
          />
          <NotificationsCenterTab
            label={formatMessage(messages.uploads)}
            badge={numberOfUploads}
            value="uploads"
          />
        </Tabs.TabsList>
        <Tabs.TabPanel value="notifications">
          <Box
            sx={{
              maxHeight: 420,
              minHeight: 200,
              overflowY: 'auto',
              width: '100%',
            }}
            py={2}
          >
            <NotificationsList />
          </Box>
        </Tabs.TabPanel>
        <Tabs.TabPanel value="uploads">
          <Box
            sx={{
              maxHeight: 420,
              minHeight: 200,
              overflowY: 'auto',
              width: '100%',
            }}
            py={2}
          >
            <NotificationsUploads />
          </Box>
        </Tabs.TabPanel>
      </Tabs>
    </NotificationsCenterComponent>
  );
};
